export const PRODUCT_CODE_KEY = 'travel.productCode'

export const TRAVEL_KEY = 'qic-qatar-travel'

export const HOME_PROMOCODE_KEY = 'home-promocode'

export const URL_PARAMS_STORAGE_KEY = 'urlParamsKey'
